import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { PageRequest } from '@qwyk/ui-standalone';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

import { ShipmentPackage } from './shipment-packages.models';
import * as ShipmentPackagesActions from './shipment-packages.actions';
import * as ShipmentPackagesSelectors from './shipment-packages.selectors';


@Injectable()
export class ShipmentPackagesFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(ShipmentPackagesSelectors.getShipmentPackagesLoading)
    );
    error$ = this.store.pipe(
        select(ShipmentPackagesSelectors.getShipmentPackagesError)
    );
    allShipmentPackages$ = this.store.pipe(
        select(ShipmentPackagesSelectors.getAllShipmentPackages)
    );
    selectedShipmentPackages$ = this.store.pipe(
        select(ShipmentPackagesSelectors.getSelected)
    );
    pagination$ = this.store.pipe(
        select(ShipmentPackagesSelectors.getShipmentPackagesPagination)
    );

    constructor(private store: Store) {}

    public selectPackage(shipmentPackage: ShipmentPackage): void {
        this.store.dispatch(
            ShipmentPackagesActions.selectShipmentPackage({ shipmentPackage })
        );
    }

    public unselectPackage(): void {
        this.store.dispatch(ShipmentPackagesActions.unselectShipmentPackage());
    }

    public loadPackages(shipmentId: string, query: PageRequest): void {
        this.store.dispatch(ShipmentPackagesActions.loadShipmentPackages({ shipmentId, query }))
    }

    public updatePackage(
        shipment: Shipment,
        shipmentPackage: ShipmentPackage
    ): void {
        this.store.dispatch(
            ShipmentPackagesActions.updateShipmentPackage({
                shipment,
                shipmentPackage,
            })
        );
    }
}
